// extracted by mini-css-extract-plugin
export default {"container":"SocialBar_container__WlxDu","social_container":"SocialBar_social_container__aUO-t"};